import React from "react";
import { BIZ } from "@/data/site";

/**
 * Simple stylized "BBB" badge — links to the business's BBB profile
 * (falls back to the BBB search URL if `BIZ.bbbUrl` is not yet set).
 * Two size variants:
 *  - `sm`  (32px tall) for use inside the top announcement bar
 *  - `md`  (56px tall) for the footer trust row
 * Uses inline SVG so it never depends on an external image asset.
 */
export default function BBBBadge({ size = "sm", className = "", onDark = false }) {
  const href =
    BIZ.bbbUrl ||
    `https://www.bbb.org/search?find_text=${encodeURIComponent(BIZ.name)}&find_loc=${encodeURIComponent(
      `${BIZ.city}, ${BIZ.stateShort}`
    )}`;
  const isSm = size === "sm";
  const box = isSm ? "h-8 px-2.5" : "h-14 px-4";
  const stripe = isSm ? "text-[9px]" : "text-[11px]";
  const bbb = isSm ? "text-[15px]" : "text-2xl";
  const sub = isSm ? "text-[8px]" : "text-[10px]";
  const border = onDark ? "border-white/20" : "border-white/40";
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Better Business Bureau profile"
      data-testid="bbb-badge"
      className={`inline-flex items-center rounded-md bg-[#005A9C] text-white border ${border} shadow-sm hover:shadow-md transition-all ${box} ${className}`}
      style={{ fontFamily: "Outfit, system-ui, sans-serif" }}
    >
      <div className="flex items-center gap-2">
        <span
          aria-hidden="true"
          className={`inline-flex items-center justify-center font-black tracking-tight leading-none ${bbb}`}
        >
          BBB
        </span>
        <div className="flex flex-col leading-tight border-l border-white/30 pl-2">
          <span className={`font-bold uppercase tracking-wider ${stripe}`}>Better</span>
          <span className={`font-bold uppercase tracking-wider ${stripe}`}>Business</span>
          <span className={`font-semibold uppercase opacity-90 ${sub}`}>Bureau®</span>
        </div>
      </div>
    </a>
  );
}
